import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const professionForeignAmountsService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/profession/foreign-amounts/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching profession foreign amounts list", error);
            throw error;
        }
    },

    async findByUuid(uuid: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/profession/foreign-amounts/findByUuid/${uuid}`);
            return response.data;
        } catch (error) {
            console.error("Error findByUuid profession foreign amounts", error);
            throw error;
        }
    },

    async save(profession: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/profession/foreign-amounts/save`,
                profession
            );
            return response.data;
        } catch (error) {
            console.error("Error save profession foreign amounts", error);
            throw error;
        }
    },

    async deleteByUuid(uuid: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/profession/foreign-amounts/deleteByUuid/${uuid}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteByUuid profession foreign amounts", error);
            throw error;
        }
    }
}

export default professionForeignAmountsService;